import React from "react"

import "bootstrap/dist/css/bootstrap.min.css"

import "./styles.scss"
import { Helmet } from "react-helmet"

export const Layout = props => {
  if (typeof window !== "undefined") {
    return (
      <div className="layout-container">
        <Helmet>
          <meta property="title" content="PALM & ICE, 27 October 2020" />
          <meta
            property="description"
            content="SAVE THE DATE 27 October 2020"
          />
          <meta property="og:title" content="PALM & ICE, 27 October 2020" />
          <meta
            property="og:description"
            content="SAVE THE DATE 27 October 2020"
          />
          <meta property="og:image" content="/favicon-32x32.png" />
          <title>PALM & ICE, 27 October 2020</title>
        </Helmet>
        {props.children}
      </div>
    )
  }
  return null
}
